module.exports = __webpack_public_path__ + "static/media/ic_commerce.68406879.svg";